/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 outfit1.glb 
*/

import React from "react";
import { useGLTF } from "@react-three/drei";

export default function Model(props) {
	const { nodes, materials } = useGLTF("models/outfit1.glb");
	return (
		<group {...props} dispose={null}>
			<mesh
				geometry={nodes.bodysuit2_1.geometry}
				material={materials["Soft Suede Fabric.002"]}
				position={[0, -0.219, 0.245]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={0.011}
			/>
			<mesh
				geometry={nodes.bodysuit2_2.geometry}
				material={materials["Satin Fabric.003"]}
				position={[0, -0.219, 0.245]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={0.011}
			/>
			<mesh
				geometry={nodes.bodysuit2001.geometry}
				material={materials["CCL Metal 002.002"]}
				position={[0, -0.219, 0.245]}
				rotation={[Math.PI / 2, 0, 0]}
			/>
			<mesh
				geometry={nodes.hair001.geometry}
				material={materials["hair_defaultMat4.002"]}
				position={[0.005, 0.028, 0.291]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={0.011}
			/>
			<mesh
				geometry={nodes.hair001_1.geometry}
				material={materials["Dummy_SHD1.002"]}
				position={[0.005, 0.028, 0.291]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={0.011}
			/>
			<mesh
				geometry={nodes.Retopo_body002.geometry}
				material={materials["Marble.002"]}
				position={[0.005, 0.028, 0.291]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={0.011}
			/>
			<mesh
				geometry={nodes.Retopo_shoes_r003.geometry}
				material={materials["Material.002"]}
				position={[0.005, 0.028, 0.291]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={0.011}
			/>
		</group>
	);
}

useGLTF.preload("models/outfit1.glb");
